<div class="body-container">
  <div class="main-container content-bg1">
    <div id="sidebar" class="sidebar sidebar-white sidebar-fixed sidebar-backdrop expandable d-none d-xl-block"
      data-swipe="true" data-dismiss="true">
      <div class="sidebar-inner shadow-sm">
        <div class="flex-grow-1 ace-scroll" ace-scroll>
          <div class="sidebar-section-item mx-0  fadeable-left fadeable-top">
            <div class="fadeinable">
              <div class="left-menu-logo small">
                <i class="nelt-logo"></i>
              </div>
            </div>

            <div class="fadeable hideable">
              <div class="py-2 d-flex flex-column align-items-center">
                <div class="left-menu-logo">
                  <i class="nelt-logo"></i>
                </div>
                <div class="collapse" id="id-user-menu">
                  <div class="mt-3">
                    <a href="#"
                      class="btn bgc-blue-l2 btn-brc-white btn-h-outline-blue radius-round py-2 px-1 text-center border-2 shadow-sm">
                      <i class="fa fa-envelope w-4 text-110 text-blue-m1"></i>
                    </a>

                    <a href="#"
                      class="btn bgc-purple-l2 btn-brc-white btn-h-outline-purple radius-round py-2 px-1 text-center border-2 shadow-sm">
                      <i class="fa fa-users w-4 text-110 text-purple-m1"></i>
                    </a>

                    <a href="#"
                      class="btn bgc-warning-l2 btn-brc-white btn-h-outline-warning radius-round py-2 px-1 text-center border-2  shadow-sm">
                      <i class="fa fa-star w-4 text-110 text-orange-m1"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nav flex-column mt-2 has-active-border" role="navigation" aria-label="Main">
            <li class="nav-item-caption">
              <span class="fadeinable mt-n2 text-125">&hellip;</span>
            </li>
            <li class="nav-item" *ngIf="auth.isAuthenticated">
              <a routerLink="/home" class="nav-link">
                <span class="nav-link-background"></span>
                <i class="nav-icon fa-solid fa-house"></i>
                <span class="nav-text fadeable">
                  <span>{{ translationManager.getTranslation('Насловна') }}</span>
                </span>
              </a>
              <b class="sub-arrow"></b>
            </li>

            <li class="nav-item" *ngIf="auth.isAuthenticated">
              <a routerLink="/auctions" class="nav-link">
                <span class="nav-link-background"></span>
                <i class="nav-icon fa fa-briefcase-clock"></i>
                <span class="nav-text fadeable">
                  <span>{{ translationManager.getTranslation('MenuAuctions') }}</span>
                </span>
              </a>
              <b class="sub-arrow"></b>
            </li>
            <li class="nav-item" *ngIf="auth.isAuthenticated">
              <a routerLink="/supplier-rounds" class="nav-link">
                <span class="nav-link-background"></span>
                <i class="nav-icon fa fa-box"></i>
                <span class="nav-text fadeable">
                  <span>{{ translationManager.getTranslation('MenuSupplierRounds') }}</span>
                </span>
              </a>
              <b class="sub-arrow"></b>
            </li>
            <li class="nav-item" *ngIf="auth.isAuthenticated">
              <a routerLink="/supplier-user" class="nav-link">
                <span class="nav-link-background"></span>
                <!-- <i class="nav-icon fa fa-tachometer-alt"></i> -->
                <i class="nav-icon fa-solid fa-user"></i>
                <span class="nav-text fadeable">
                  <span>{{ translationManager.getTranslation('Корисник') }}</span>
                </span>
              </a>
              <b class="sub-arrow"></b>
            </li>


          </div>
        </div>
      </div>
    </div>
    <div role="main" class="main-content">
      <nav class="navbar navbar-sm navbar-expand-lg navbar-fixed navbar-white">
        <div class="navbar-inner">

          <div class="justify-content-xl-between d-flex h-100 align-items-center">

            <button type="button"
              class="btn text-grey-m2 btn-burger burger-arrowed static collapsed ml-2 d-flex d-xl-none"
              data-toggle-mobile="sidebar" data-target="#sidebar" aria-controls="sidebar" aria-expanded="false"
              aria-label="Toggle sidebar">
              <span class="bars"></span>
            </button>

            <button type="button"
              class="sidebar-toggle btn text-grey-m2 btn-burger align-self-center mx-2 d-none d-xl-flex btn-h-light-primary"
              data-toggle="sidebar" data-target="#sidebar" aria-controls="sidebar" aria-expanded="true"
              aria-label="Toggle sidebar">
              <span class="bars"></span>
            </button>
            <div class="header-info">
              <span>{{ translationManager.getTranslation('Систем еНабавке | Axians') }}</span>
            </div>
          </div>
          <div class="dropdown-menus">
            <app-dropdown-menu #userAppDropdown>
              <div class="app-dropdown-menu" style="float: right;">

                <div class="app-dropdown-menu-header">

                  <!-- <div *ngIf="auth.isAuthenticated" class="app-user" (click)="userAppDropdown.show = !userAppDropdown.show"> -->
                  <div [ngClass]="{ 'app-user': auth.isAuthenticated, 
                             'user-not-logged': !auth.isAuthenticated}" (click)="userAppDropdown.show = !userAppDropdown.show">
                    <span *ngIf="!auth.isPresentImage()">{{auth.user?.firstName ? auth.user?.firstName[0] :
                      ''}}{{auth.user?.lastName ? auth.user?.lastName[0] : ''}}</span>
                      <span *ngIf="auth.isPresentImage()">
                        <img style="width: 45px;height: 45px;" src="{{auth.user?.photoimg}}">
                      </span>
                  </div>

                </div>

                <div class="app-dropdown-menu-body" *ngIf="userAppDropdown.show">
                  <div class="app-dropdown-menu-content">
                    <ng-container *ngIf="auth.isAuthenticated">
                      <div>
                        <div class="app-dropdown-menu-item-header">
                          <span>{{ translationManager.getTranslation('Корисник') }}</span>
                        </div>
                        <div class="app-dropdown-menu-item">
                          <span><b>{{auth.user?.firstName}} {{auth.user?.lastName}}</b></span>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="translationManager.languages?.languages?.length > 1">
                      <div>
                        <div class="app-dropdown-menu-item-header">
                          <span>{{ translationManager.getTranslation('Језик') }}</span>
                        </div>
                        <div class="app-dropdown-menu-item clickable"
                          *ngFor="let language of translationManager.languages.languages"
                          (click)="translationManager.setLanguage(language.culture)">
                          <span>{{ language.name }}</span>
                        </div>
                      </div>
                    </ng-container>

                    <div class="app-dropdown-menu-item-header">
                    </div>
                    <div class="app-dropdown-menu-item clickable"
                      (click)="logout(); userAppDropdown.show = !userAppDropdown.show" *ngIf="auth.isAuthenticated">
                      <span>{{ translationManager.getTranslation('Одјави се') }}</span>
                    </div>
                    <div class="app-dropdown-menu-item clickable"
                      (click)="login(); userAppDropdown.show = !userAppDropdown.show" *ngIf="!auth.isAuthenticated">
                      <span>{{ translationManager.getTranslation('Пријави се') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </app-dropdown-menu>
          </div>
        </div>
      </nav>

      <router-outlet></router-outlet>

      <footer class="footer d-none d-sm-block">
        <div class="app-footer">
          <div class="nelt-logo-footer"></div><span>{{ translationManager.getTranslation('eSourcing | Axians') }} &copy;
            {{year}}</span>
        </div>
      </footer>
    </div><!-- /main -->
  </div><!-- /.main-container -->
</div>
